export default "__VITE_ASSET__CqoPomT4__"